import {
  Component,
  ElementRef,
  Input,
  OnChanges,
  SimpleChanges,
  ViewChild,
} from '@angular/core';
import { AppService } from 'src/app/app.service';
import { TableService } from '../../services/tableService/table.service';

@Component({
  selector: 'app-export-aditional-charges',
  standalone: false,
  templateUrl: './export-aditional-charges.component.html',
  styleUrl: './export-aditional-charges.component.scss',
})
export class ExportAditionalChargesComponent implements OnChanges {
  @Input() data: any;
  @Input() raData: any;
  @Input() type: any;
  @ViewChild('additionCharge') chargecontainer: ElementRef | any;

  mauntList: any;
  tableData: any;
  public chargesList: any = [];
  tableType: string = 'ftl';

  constructor(
    public appService: AppService,
    private tableService: TableService
  ) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['data']?.currentValue) {
      let bindData = changes['data'].currentValue;
      this.tableData = null;
      this.chargesList = bindData.charge;
      this.data = bindData.data;
      this.tableData = bindData.name;

      this.getCountryList(bindData.maut);
    }
    if (changes['type']?.currentValue) {
      this.tableType = changes['type']?.currentValue;
    }
    // this.styleUpdate();
  }

  getCountryList(evt: any) {
    let countryListArr = this.appService.countryListArr;
    const convertedData = evt.map((item: any) => {
      const countryObj = countryListArr.find(
        (country: any) => country.CountryName === item.country
      );
      const countryId = countryObj ? countryObj.CountryID : null;
      return {
        country: countryId,
        rate: parseFloat(item.rate),
      };
    });
    this.mauntList = convertedData;
    return this.mauntList;
  }

  findCountryName(i: number): string {
    return i
      ? this.appService.countryListArr.find((item: any) => item.CountryID === i)
          .CountryName
      : '';
  }

  formatElementData(val: any) {
    return '' + Number(val).toFixed(2);
  }
  formatMautData(val: any) {
    return '' + Number(val).toFixed(3);
  }

  getHtml(htmlString: string) {
    return htmlString.replace(/\n/g, '<br>');
  }

  // styleUpdate(){
  //   let matRow = this.chargecontainer?.nativeElement.querySelectorAll('.mat-mdc-row');
  //   let matHeader = this.chargecontainer?.nativeElement.querySelectorAll('.mat-mdc-header-row');
  //       matRow.forEach((component: any) => {
  //         component.style.height = `${ this.tableService.newHeight+4}px`;
  //     });
  //     matHeader.forEach((component: any) => {
  //         component.style.height = `${ this.tableService.newHeight+4}px`;
  //     });
  // }
}
